import { CI_ENV } from 'app/utils/constants/env.constants'

import { SendGA4EventProps } from './utils/googleAnalytics.types'

export const useSendGoogleAnalyticsEvent = () => {
  const hasActiveGTM =
    CI_ENV === 'production' && !!process.env.NEXT_PUBLIC_GTM_ID

  const sendGA4Event = ({ eventName, ...eventParams }: SendGA4EventProps) => {
    if (!hasActiveGTM || !window.dataLayer) return

    const isEcommerce = eventName !== 'login' && eventName !== 'sign_up'

    if (isEcommerce) {
      window.dataLayer.push({ ecommerce: null })
    }

    window.dataLayer.push({ event: eventName, ...eventParams })
  }

  return { sendGA4Event }
}
